import { AxiosResponse } from "axios";

export type RequestError = {
  errors: {
    loc: string[];
    msg: string;
  }[];
  python_exc: string;
  service: string;
  type: string;
  non_field_errors?: string[];
};

export type Money = {
  amount: number;
  currency: string;
};

export enum PaymentType {
  Cash = "cash",
  App = "app",
  Terminal = "terminal",
}

export type StaffMe = {
  id: string;
  first_name: string;
  last_name: string;
  is_superuser: boolean;
  roles: string[];
};

export type StaffMeResponse = {
  result: StaffMe;
};

export type LoginResponse = {
  result: {
    access_token: string;
    refresh_token: string;
  };
};

export type LoginVariables = { username: string; password: string };

export type RefreshTokenVariables = {
  refresh_token: string;
  shop_key?: string;
  app_key?: string;
};

export type RefreshTokenResponse = AxiosResponse<{
  result: {
    refresh_token: string;
    access_token: string;
  };
}>;

export type StaffStoresResponse = {
  results: {
    id: string;
    name: string;
    key: string;
    address: string;
    latitude: number;
    longitude: number;
    geolocation: string;
    url: string;
  }[];
  count: number;
};

export type StaffStoresVariables = {
  app_key?: string;
};

export type StaffStoreDetailsResponse = {
  result: {
    id: string;
    name: string;
    key: string;
    address: string;
    latitude: number;
    longitude: number;
    geolocation: string;
    url: string;
  };
};

export type StaffStoreDetailsVariables = {
  store_key: string;
};

export type StaffStoreAppsResponse = {
  results: {
    id: string;
    name: string;
    key: string;
    icon: string;
    url: string;
  }[];
  count: number;
};

export type StaffStoreAppDetailsResponse = {
  result: {
    id: string;
    name: string;
    key: string;
    icon: string;
    url: string;
    services: AppService[];
  };
};

export type AppService = {
  id: string;
  name: string;
  key: string;
  url: string;
};

export type StaffStoreAppDetailsVariables = {
  app_key: string;
  store_key: string;
};
